import { Subject } from 'rxjs';

export class PessoaSharedDataService {

  private updateList = new Subject<boolean>();
  updateList$ = this.updateList.asObservable();

  private updateDadosBasico = new Subject<any>();
  updateDadosBasico$ = this.updateDadosBasico.asObservable();

  private updateDadosContato = new Subject<any>();
  updateDadosContato$ = this.updateDadosContato.asObservable();

  private resetForm = new Subject<any>();
  resetForm$ = this.resetForm.asObservable();

  constructor() { }

  public setUpdateList(data: boolean): void {
    this.updateList.next(data);
  }

  public setUpdateDadosBasico(data: any): void {
    this.updateDadosBasico.next(data);
  }

  public setUpdateDadosContato(data: any): void {
    this.updateDadosContato.next(data);
  }

  public setResetForm(data: any): void {
    this.resetForm.next(data);
  }
}
